export const INITIAL_PAGE = 0
export const INITIAL_COUNT = 20
export const LOAD_MORE_COUNT = 10
export const INITIAL_CHANNELS_PAGE = 0
export const INITIAL_CHANNELS_COUNT = 1 // ask only for 1 channel, to speed up loading
